import React from "react"

const Footer = props => {
    return (
      <footer className="footer">
          <p className="footer__p">All content &copy; OnTrac Ltd. 2022</p>
          <p className="footer__p"><a className="footer__a" href="mailto:enquiries@on-trac.co.uk">enquiries@on-trac.co.uk</a></p>
      </footer>
    )
}

export default Footer
